import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { DateTimeService } from 'src/app/shared/datetime/datetime.service';
import { PollingLocationLoggedPoll } from '../../models/polling-location-logged-poll';
import { TransportService } from '../../services/transport.service';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../../shared/grid/biz-grid.directive';
import { DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';


@Component({
    selector: 'ep-transport-locations-log-details',
    templateUrl: './transport-locations-log-details.component.html',
    styleUrls: ['./transport-locations-log-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective, DxiColumnModule, DxTemplateModule]
})
export class TransportLocationsLogDetailsComponent implements OnInit {
    @Input() loggedPoll: PollingLocationLoggedPoll = null;
    getPolls$: Observable<PollingLocationLoggedPoll>;
    logs: PollingLocationLoggedPoll[] = [];
    dateFormat: (date: Date) => string;

    constructor(
        private transportService: TransportService,
        private dateTimeService: DateTimeService
    ) {
        this.dateFormat = this.dateTimeService.getDevExpressDateTimeWithMsFunction;
    }

    ngOnInit(): void {
        this.getPolls$ = this.transportService.getPollLogForInConfiguration(this.loggedPoll.Id);
        this.refresh();
    }

    refresh(): void {
        this.getPolls$.subscribe(result => this.logs.push(result));
    }

    customizeText(cellInfo) {
        return cellInfo.valueText.replaceAll("\n", "<br/>\n").replaceAll("] [Error] [", "] <span style=\"color:red;\">[Error]</span> [").replaceAll("] [Warning] [", "] <span style=\"color:orange;\">[Warning]</span> [").replaceAll("] [Information] [", "] <span style=\"color:blue;\">[Information]</span> [");
    }
}
